/** =========================================================
 * User certificates controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-user-certificates')
    .controller('UserCertificatesController', UserCertificatesController);

  UserCertificatesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function UserCertificatesController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page user certificates',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'user_certificate',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [
            'user'
          ]
        },
        filters: angular.copy($stateParams.filters),
        helpers: {
        },
        resources: [
          'user'
        ],
        fields: [{
          title: 'Certificate id',
          key: 'uid',
          order: true
        }, {
          title: 'Certificate date',
          key: 'issue_date',
          order: true
        }, {
          title: 'User',
          key: null,
          value: function (item) {
            return item.user.name;
          }
        }],
        add: {
          template: 'app/views/dialogs/item-user-certificate.html',
          item: {}
        },
        edit: {
          template: 'app/views/dialogs/item-user-certificate.html',
          except: ['user']
        },
        delete: {},
        linkButtons: [{
          title: 'User',
          icon: 'icon-user',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('user view'),
          action: function (item) {
            try {
              $state.go('app.page-users', {
                filters: [{
                  name: $translate.instant('User') + ': ' + item.user.name,
                  attr: 'where',
                  value: [
                    ['id', '=', item.user.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
